import { useEffect } from 'react';
import { updatePageSEO } from '../utils/seoManager';

/**
 * Custom React Hook to synchronize page SEO and Schema.org metadata
 * @param {Object} seoConfig
 */
export const useSEO = (seoConfig) => {
  useEffect(() => {
    if (!seoConfig) return;
    updatePageSEO(seoConfig);
  }, [
    seoConfig?.title,
    seoConfig?.description,
    seoConfig?.keywords,
    seoConfig?.canonicalUrl,
    seoConfig?.ogTitle,
    seoConfig?.ogDescription,
    seoConfig?.ogImage,
    seoConfig?.ogUrl,
    seoConfig?.structuredData
  ]);
};

export default useSEO;
